import { BaseClientService } from "../BaseClientService";

export class AdminBaseService extends BaseClientService {
  url: string;
  constructor(adminType: string) {
    super();
    this.url = `${this.API_BASE_URL}/api/admin/${adminType}`;
  }
}
